import {X} from "react-feather";
import {togglePanel} from "global/slices";
import {useTheme} from "styled-components";
import {Fragment} from "react/jsx-runtime";
import {Container, Content} from "./styled";
import {IconButton, Line, Row, Typography} from "components";
import {useAppDispatch, useAppSelector, useBreakpoints} from "hooks";

interface PanelProps {}

export const Panel: React.FC<PanelProps> = () => {
  const {blackWhite} = useTheme();
  const dispatch = useAppDispatch();
  const {upLg, downSm} = useBreakpoints();
  const {panel} = useAppSelector("layout");
  const {component, title, width, opened} = panel;
  return (
    <Container
      style={{
        width: upLg ? undefined : downSm ? "100vw" : width,
        display: upLg ? "block" : opened ? "block" : "none",
      }}
    >
      {component ? (
        <Fragment>
          <Row padding=".5rem 0" gap={10}>
            <IconButton
              size={30}
              icon={<X strokeWidth={2} size={20} color={blackWhite} />}
              onClick={() => dispatch(togglePanel({type: "close"}))}
              style={{
                boxShadow: "2px 12x 3px 1px rgba(0, 0, 0, 1)",
              }}
            />
            <Typography fontFamily="Rubik-SemiBold" fontSize={18}>
              {title}
            </Typography>
          </Row>
          <Line margin={0} />
          <Content>{component}</Content>
        </Fragment>
      ) : (
        <Fragment />
      )}
    </Container>
  );
};
